// extracted by mini-css-extract-plugin
module.exports = {"cont":"_93444fe79c--cont--3hZvQ","top":"_93444fe79c--top--3qG5t","cian-logo":"_93444fe79c--cian-logo--BqHu-"};